"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableMenuGroupContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const ExpandableMenuGroupContainer = exports.ExpandableMenuGroupContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__ExpandableMenuGroupContainer",
  componentId: "sc-1xah77q-0"
})(["cursor:pointer;"]);